import { useNavigate, useSearch } from '@tanstack/react-router';

import type { DomainsSortDirection, DomainsSortProperty } from './model';
import {
  domainsRouteSearchSchema,
  parseDomainsRouteSearch,
  serializeDomainsRouteSearch,
} from './domainsRouteSearch';

export function useDomainsRouteFilters(publisherScoped = false) {
  const navigate = useNavigate({
    from: publisherScoped ? '/supply/publishers/$publisherId/details/domains' : '/supply/domains',
  });
  const search = useSearch({ strict: false });
  const filter = parseDomainsRouteSearch(domainsRouteSearchSchema(search));
  const update = (next: typeof filter) =>
    void navigate({ search: serializeDomainsRouteSearch(next), replace: true });

  return {
    filter,
    setSearch: (searchTerm: string) => {
      update({ ...filter, searchTerm, page: 0 });
    },
    setPublishers: (publisherIds: string[]) => {
      update({ ...filter, publisherIds, page: 0 });
    },
    setSort: (sortProperty: DomainsSortProperty | null, sortDirection: DomainsSortDirection) => {
      update({ ...filter, sortProperty, sortDirection, page: 0 });
    },
    setPagination: (page: number, size: number) => {
      update({ ...filter, page: size === filter.size ? page : 0, size });
    },
  };
}
